<template>
  <div class="ex">
    <div
      class="exhibition_card"
      @click="clicked_exhibition(exhibition_json.exhibition_slug)"
    >
      <div class="overlay_onTop">
        <div class="text">Experience in 3D</div>
      </div>
      <div class="data_body">
        <p class="exhibition_name">{{ exhibition_json.exhibition_title }}</p>
        <!-- <b-img-lazy fluid rounded  class="exhibition_image " :src="exhibition_json.exhibition_image"   ></b-img-lazy> -->

        <div
          class="thumb"
          v-bind:style="{ 'background-image': 'url(' + image + ')' }"
        ></div>

        <p class="exhibition_description">
          {{ exhibition_json.exhibition_description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheExhibitionCard",
  props: ["exhibition_json"],
  data() {
    return {
      image: "",
      imageUrl: "",
    };
  },
  mounted: function () {
    this.setImage();
  },
  methods: {
    clicked_exhibition(exhibition_slug) {
      let navigateBackTo = this.$store.state.navigateBackTo;
      navigateBackTo.required = true;
      navigateBackTo.url = this.$router.currentRoute.fullPath;
      navigateBackTo.metaInfo = {};

      // this.$router.push({name: "ThreeD", params : {gallery_type : "exhibition", exhibition_slug : exhibition_slug}})
      this.$router.push(`/three-d?exhibition=${exhibition_slug}`);
    },

    setImage() {
      this.imageUrl = this.exhibition_json.exhibition_image;
      this.image = "";
      var that;
      var highResImage = new Image();
      that = this;
      highResImage.onload = function () {
        that.image = that.imageUrl;
      };
      highResImage.src = this.imageUrl;
    },
  },
};
</script>

<style scoped>
.thumb {
  display: inline-block;
  width: 250px;
  height: 250px;
  background: center;
  background-size: cover;
}

.text {
  overflow: visible;
  white-space: nowrap;
  line-height: 22px;
  text-align: center;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  color: rgba(12, 15, 102, 1);
  transition: 0.3s ease;
}

.data_body:hover {
  opacity: 0.2;
}

.exhibition_card {
  cursor: pointer;
  border: none;
  flex-grow: 1;
  overflow: hidden;
}

.exhibition_card:hover {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  transition: 0.3s ease;
}

.exhibition_card:hover .overlay_onTop {
  opacity: 1;
}

.exhibition_name {
  overflow: visible;
  white-space: nowrap;
  line-height: 22px;
  text-align: left;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 19px;
  color: rgba(12, 15, 102, 1);
}

.exhibition_image {
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  object-fit: contain;
}

.overlay_onTop {
  position: absolute;
  left: 50%;
  top: 50%;
  transition: 0.5s ease;
  opacity: 0;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.exhibition_description {
  overflow: hidden;
  text-align: left;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(12, 15, 102, 1);
  overflow: hidden;
  text-align: justify;
  text-justify: inter-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
@media (max-width: 700px) {
  .thumb {
    width: 100px;
    height: 100px;
  }

  .exhibition_name {
  overflow: visible;
  white-space: nowrap;
  line-height: 22px;
  text-align: center;
  font-family: "Titillium Web", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: small;
  color: rgba(12, 15, 102, 1);
}
  /* .ex{
        width:30%
    } */
}
</style>